{
  "helloWorld": "Salut, Lume!",
  "clickMe": "Apasă aici",
  "healthCheckFailed": "Verificarea stării a eșuat",
  "errors": {
    "unexpected": "A apărut o eroare neașteptată"
  },
  "error": {
    "title": "Ceva nu a funcționat",
    "description": "A apărut o eroare neașteptată. Poți încerca din nou sau te poți întoarce acasă.",
    "tryAgain": "Încearcă din nou",
    "goHome": "Pagina principală"
  },
  "dev": {
    "errorPreview": "Previzualizare eroare"
  },
  "actions": {
    "label": "Acțiuni",
    "edit": "Editează",
    "delete": "Șterge",
    "save": "Salvează",
    "cancel": "Anulează",
    "expand": "Extinde",
    "collapse": "Restrânge"
  },
  "validation": {
    "tooLong": "Trebuie să fie maximum {{max}} caractere",
    "tooShort": "Obligatoriu",
    "invalidFormat": "Format invalid",
    "invalid": "Valoare invalidă"
  },
  "nav": {
    "workspace": "Spațiu de lucru",
    "controlCenter": "Centru de comandă",
    "jobs": "Joburi",
    "analytics": "Analiză",
    "company": "Companie",
    "agentCommunications": "Comunicări agent",
    "integrations": "Integrări",
    "suggestedCandidates": "Candidați sugerați",
    "unsolicitedApplications": "Candidaturi nesolicitate",
    "team": "Echipă",
    "templates": "Șabloane",
    "workflow": "Flux de lucru",
    "settings": "Setări",
    "language": "Limbă",
    "help": "Ajutor",
    "logout": "Deconectare",
    "administration": "Administrare",
    "adminTenant": "Setări chiriaș",
    "adminOrganizations": "Organizații",
    "adminDepartments": "Departamente",
    "adminFeedback": "Feedback",
    "openMenu": "Deschide meniu",
    "mcp": "MCP",
    "orgSettings": "Setări organizație"
  },
  "admin": {
    "tenants": {
      "title": "Chiriași",
      "newTenant": "Chiriaș nou",
      "columns": {
        "name": "Nume",
        "createdAt": "Creat la",
        "actions": "Acțiuni"
      },
      "createDialog": {
        "title": "Creează chiriaș",
        "namePlaceholder": "Acme Corp"
      },
      "editDialog": {
        "title": "Editează chiriaș"
      }
    },
    "tenant": {
      "title": "Setări chiriaș",
      "name": "Nume chiriaș",
      "save": "Salvează modificările",
      "saved": "Salvat"
    },
    "organizations": {
      "title": "Organizații",
      "newOrg": "Organizație nouă",
      "columns": {
        "name": "Nume",
        "slug": "Slug",
        "tenant": "Chiriaș",
        "createdAt": "Creat la",
        "actions": "Acțiuni",
        "viewWorkspace": "Vezi spațiul de lucru"
      },
      "createDialog": {
        "title": "Creează organizație",
        "namePlaceholder": "Acme Corp",
        "slugPlaceholder": "acme-corp",
        "newTenant": "Chiriaș nou",
        "existingTenant": "Chiriaș existent",
        "tenantName": "Nume chiriaș",
        "tenantNamePlaceholder": "Acme Corp",
        "selectTenant": "Selectează chiriaș"
      },
      "editDialog": {
        "title": "Editează organizație",
        "language": "Limbă",
        "languagePlaceholder": "Selectează limba"
      },
      "deleteConfirm": {
        "title": "Șterge organizație",
        "description": "Aceasta va șterge și toate departamentele din această organizație. Această acțiune nu poate fi anulată.",
        "confirm": "Șterge",
        "cancel": "Anulează"
      }
    },
    "departments": {
      "title": "Departamente",
      "newDept": "Departament nou",
      "columns": {
        "name": "Nume",
        "slug": "Slug",
        "createdAt": "Creat la",
        "actions": "Acțiuni"
      },
      "createDialog": {
        "title": "Creează departament",
        "namePlaceholder": "Inginerie",
        "slugPlaceholder": "inginerie"
      },
      "editDialog": {
        "title": "Editează departament"
      },
      "deleteConfirm": {
        "title": "Șterge departament",
        "description": "Această acțiune nu poate fi anulată.",
        "confirm": "Șterge",
        "cancel": "Anulează"
      }
    },
    "viewingOrg": {
      "banner": "Vizualizare: {{name}}",
      "leave": "Părăsește"
    },
    "feedback": {
      "title": "Feedback",
      "columns": {
        "rating": "Evaluare",
        "modality": "Tip",
        "candidate": "Candidat",
        "job": "Job",
        "org": "Organizație",
        "notes": "Note",
        "date": "Dată"
      },
      "modality": {
        "voice": "Voce",
        "text": "Chat"
      },
      "thumbs": {
        "up": "Pozitiv",
        "down": "Negativ"
      },
      "filter": {
        "all": "Toate",
        "up": "Pozitiv",
        "down": "Negativ",
        "hasNotes": "Cu note"
      },
      "stats": {
        "title": "Rată negativă",
        "period": "Ultimele 7 zile",
        "wowUp": "+{{delta}}pp",
        "wowDown": "-{{delta}}pp",
        "wowFlat": "Fără schimbări",
        "wowNoPrev": "Fără date anterioare",
        "noData": "Fără date"
      },
      "noFeedback": "Niciun feedback încă",
      "noNotes": "Niciun comentariu scris"
    }
  },
  "team": {
    "title": "Echipă",
    "invite": "Invită colegi",
    "search": "Caută după nume, email, departament...",
    "department": "Departament",
    "roles": {
      "admin": "Administrator",
      "org_manager": "Manager organizație",
      "dept_manager": "Manager departament",
      "user": "Utilizator"
    },
    "columns": {
      "name": "Nume",
      "email": "Email",
      "role": "Rol",
      "actions": "Acțiuni"
    },
    "inviteDialog": {
      "title": "Invită coleg",
      "name": "Nume",
      "namePlaceholder": "Ion Popescu",
      "email": "Adresă de email",
      "emailPlaceholder": "coleg@companie.ro",
      "role": "Rol",
      "departments": "Departamente",
      "submit": "Trimite invitația"
    },
    "actions": {
      "changeRole": "Schimbă rolul",
      "addDepartment": "Adaugă la departament",
      "removeDepartment": "Elimină din departament",
      "removeFromOrg": "Elimină din organizație"
    },
    "noResults": "Niciun rezultat găsit.",
    "noMembers": "Niciun membru în echipă încă."
  },
  "jobs": {
    "title": "Joburi",
    "backToJobs": "Joburi",
    "newJob": "Job nou",
    "createNewJob": "Creează job nou",
    "importFromAts": "Importă din {{atsName}}",
    "searchPlaceholder": "Caută joburi...",
    "completedPlaceholder": "{{completed}} din {{total}} finalizate",
    "tabs": {
      "active": "Active",
      "archived": "Arhivate"
    },
    "columns": {
      "name": "Nume",
      "createdBy": "Creat de",
      "createdAt": "Creat la",
      "actions": "Acțiuni"
    },
    "empty": "Niciun job găsit.",
    "emptyTitle": "Niciun job încă",
    "emptyDescription": "Creează primul tău job sau importă din ATS pentru a începe.",
    "emptyArchivedTitle": "Niciun job arhivat",
    "emptyArchivedDescription": "Joburile arhivate vor apărea aici.",
    "emptySearchDescription": "Niciun job nu corespunde căutării tale.",
    "actions": {
      "archive": "Arhivează",
      "archiveConfirmTitle": "Arhivează job",
      "archiveConfirmDescription": "Ești sigur că vrei să arhivezi acest job? Va fi mutat în fila Arhivate.",
      "archiveSuccess": "Job arhivat",
      "archiveError": "Nu s-a putut arhiva jobul. Încearcă din nou."
    },
    "createError": "Nu s-a putut crea jobul. Te rugăm să încerci din nou.",
    "status": {
      "active": "Activ",
      "archived": "Arhivat"
    },
    "setupStatus": {
      "draft": "Ciornă",
      "questions_pending": "Configurare necesară",
      "ready": "Pregătit",
      "active": "Activ"
    },
    "applicantSync": {
      "syncingBanner": "Se preiau candidații din {{provider}}...",
      "failedBanner": "Sincronizarea candidaților a eșuat",
      "adminActions": "Acțiuni administrator",
      "resyncLabel": "Sincronizează candidații acum",
      "lastSyncedAt": "Ultima sincronizare: {{date}}",
      "addDemoApplicant": "Adaugă candidat demo"
    },
    "detail": {
      "tabs": {
        "candidates": "Candidați",
        "results": "Rezultate",
        "settings": "Setări"
      },
      "info": {
        "title": "Informații job",
        "employer": "Angajator",
        "location": "Locație",
        "description": "Descriere",
        "modality": "Modalitate interviu",
        "languages": "Limbi",
        "atsProvider": "Furnizor ATS",
        "atsId": "ID job ATS",
        "noDescription": "Nicio descriere furnizată."
      },
      "questions": {
        "title": "Întrebări de interviu",
        "empty": "Nicio întrebare configurată pentru acest job.",
        "optional": "Opțional",
        "categories": {
          "eligibility": "Eligibilitate",
          "nice_to_have": "De dorit",
          "job_preview": "Așteptări job",
          "assessment": "Evaluare",
          "information": "Informații"
        }
      }
    }
  },
  "wizard": {
    "step": "Pasul {{current}} din {{total}}",
    "back": "Înapoi",
    "next": "Continuă",
    "goLive": "Activează",
    "saveAndContinue": "Salvează și continuă",
    "manual": {
      "title": "Job nou",
      "step1Title": "Informații de bază",
      "step2Title": "Întrebări de interviu",
      "step3Title": "Confirmă și activează"
    },
    "import": {
      "title": "Importă din ATS",
      "step0Title": "Selectează joburi",
      "step1Title": "Mapare etape",
      "step2Title": "Setări interviu",
      "step3Title": "Întrebări de interviu",
      "step4Title": "Confirmă și activează"
    },
    "stageSelector": {
      "title": "Mapare etape pipeline",
      "description": "Selectează care etapă din fiecare job corespunde fiecărei acțiuni Kiku. Pre-completate unde numele etapelor se potrivesc cu setările implicite.",
      "continue": "Continuă",
      "loading": "Se încarcă etapele…"
    },
    "basicInfo": {
      "title": "Titlu job",
      "titlePlaceholder": "ex. Inginer Software Senior",
      "description": "Descriere job",
      "descriptionPlaceholder": "Descrie rolul, responsabilitățile și cerințele...",
      "descriptionHint": "Folosit de AI pentru a genera întrebări de interviu relevante",
      "employer": "Nume angajator (opțional)",
      "employerPlaceholder": "ex. Acme Corp",
      "modality": "Format interviu",
      "modalityText": "Chat text",
      "modalityTextDesc": "Candidatul scrie răspunsurile într-o interfață de chat",
      "modalityVoice": "Interviu vocal",
      "modalityVoiceDesc": "Interviu audio în direct într-o sală virtuală",
      "languages": "Limba(ile) interviului",
      "languagesHint": "Selectează cel puțin o limbă",
      "languagesSearch": "Caută limbi…",
      "languagesEmpty": "Nicio limbă găsită.",
      "modalityRequired": "Selectează cel puțin un format de interviu",
      "languagesRequired": "Selectează cel puțin o limbă"
    },
    "atsSelector": {
      "title": "Selectează joburile de importat",
      "search": "Caută joburi...",
      "selectAll": "Selectează tot",
      "selected": "{{count}} selectate",
      "noJobs": "Niciun job activ găsit în ATS-ul tău",
      "noDescription": "Fără descriere disponibilă — AI va genera doar din titlu",
      "continue": "Continuă cu {{count}} job(uri)"
    },
    "sharedSettings": {
      "title": "Setări interviu",
      "subtitle": "Aceste setări se vor aplica tuturor joburilor importate",
      "employer": "Numele angajatorului",
      "employerPlaceholder": "ex. Acme Corp"
    },
    "questions": {
      "title": "Întrebări de interviu",
      "generateError": "Nu s-au putut genera întrebările. Te rugăm să încerci din nou.",
      "retry": "Reîncearcă",
      "generating": "Se pregătesc întrebările pentru a găsi cei mai buni candidați…",
      "generatingHint": "De obicei durează câteva secunde",
      "addQuestion": "Adaugă întrebare",
      "categories": {
        "eligibility": "Eligibilitate",
        "nice_to_have": "De dorit",
        "job_preview": "Previzualizare realistă a jobului",
        "assessment": "Evaluare",
        "information": "Colectare informații"
      },
      "categoryDescriptions": {
        "eligibility": "Întrebări da/nu despre cerințe obligatorii",
        "nice_to_have": "Întrebări da/nu despre calificări dorite dar neobligatorii",
        "job_preview": "Evidențiază un aspect provocator al rolului. Ajută candidatul să înțeleagă ce presupune rolul și previne fluctuația de personal",
        "assessment": "Întrebări comportamentale și de competențe",
        "information": "Întrebări pentru colectarea contextului — nu sunt folosite la punctare"
      },
      "categoryPurpose": {
        "eligibility": "Admis sau respins",
        "job_preview": "Admis sau respins",

        "assessment": "Punctat",
        "information": "Doar pentru informare"
      },
      "optional": "Opțional",
      "competency": "Competență",
      "scoringExamples": "Ancore de punctare",
      "editScoringExamples": "Editează ancorele de punctare",
      "regenerateScoringExamples": "Regenerează ancorele de punctare",
      "dontRegenerateScoringExamples": "Nu regenera ancorele de punctare",
      "regeneratingScoringExamples": "Se regenerează...",
      "regenerateScoringError": "Nu s-au putut regenera ancorele de punctare",
      "score1": "Scor 1 — Slab",
      "score3": "Scor 3 — Adecvat",
      "score5": "Scor 5 — Excelent",
      "aiGenerated": "Generat de AI"
    },
    "confirm": {
      "title": "Pregătit pentru activare",
      "jobsCount": "{{count}} job(uri) vor fi activate",
      "questionsCount": "{{count}} întrebare(i) de interviu",
      "modality": "Format",
      "languages": "Limbi",
      "goLiveHint": "Candidații vor putea începe interviurile imediat după activare."
    }
  },
  "login": {
    "title": "Conectează-te la Kiku",
    "subtitle": "Gestionează procesul de recrutare.",
    "cta": "Conectare",
    "waitingForLogin": "Se așteaptă conectarea…",
    "disclosure": "Interacționezi cu un sistem AI. Kiku folosește AI pentru a asista la recrutare — toate deciziile sunt supuse revizuirii umane.",
    "errors": {
      "not_provisioned": "Contul tău nu este configurat încă. Contactează administratorul.",
      "missing_code": "Autentificarea a eșuat. Te rugăm să încerci din nou.",
      "session_expired": "Sesiunea ta a expirat. Te rugăm să te conectezi din nou."
    }
  },
  "settings": {
    "profile": {
      "title": "Profil",
      "name": "Nume",
      "email": "Email",
      "role": "Rol",
      "departments": "Departamente"
    }
  },
  "integrations": {
    "title": "Integrări",
    "ats": {
      "title": "Conexiune ATS",
      "description": "Conectează-ți sistemul de urmărire a candidaților pentru a sincroniza joburi și gestiona etapele candidaților.",
      "provider": "Furnizor",
      "apiKey": "Cheie API",
      "apiKeyPlaceholder": "Introdu cheia API",
      "apiKeySet": "Cheie salvată — introdu o valoare nouă pentru a o înlocui",
      "save": "Salvează conexiunea",
      "verify": "Verifică conexiunea",
      "verifyStatus": {
        "valid": "Conectat",
        "invalid": "Cheie invalidă",
        "error": "Verificarea a eșuat",
        "idle": "Neverificat",
        "loading": "Se verifică..."
      },
      "providers": {
        "teamtailor": "Teamtailor",
        "recman": "RecMan",
        "logicmelon": "LogicMelon",
        "teamtailorDescription": "Teamtailor este o platformă de recrutare care ajută companiile să atragă, să cultive și să angajeze cei mai buni candidați.",
        "recmanDescription": "RecMan este un sistem de recrutare pentru agențiile de personal și recrutare din piața nordică.",
        "logicmelonDescription": "LogicMelon este un ATS cu postare multiplă pentru recrutare de volum mare, popular în sectorul educațional din Regatul Unit."
      }
    },
    "stageMapping": {
      "title": "Mapare etape",
      "description": "Mapează etapele din ATS la etapele de flux de lucru Kiku.",
      "initialStage": "Etapa inițială",
      "passInterviewStage": "Interviu trecut",
      "failInterviewStage": "Interviu picat",
      "recommendedStage": "Recomandat",
      "selectStage": "Selectează o etapă",
      "save": "Salvează maparea"
    },
    "errors": {
      "notConfigured": "Niciun ATS configurat. Salvează mai întâi conexiunea.",
      "fetchStagesFailed": "Nu s-au putut încărca etapele din ATS.",
      "saveFailed": "Nu s-a putut salva configurația."
    }
  },
  "applications": {
    "title": "Candidaturi",
    "newCandidate": "Candidat nou",
    "addCandidate": "Adaugă candidat nou",
    "importFromCsv": "Importă din CSV",
    "importDialog": {
      "title": "Importă candidați",
      "back": "Înapoi",
      "next": "Următorul",
      "upload": {
        "hint": "Trage și plasează un fișier CSV aici sau apasă pentru a naviga",
        "csvOnly": "Doar fișiere CSV",
        "browse": "Navighează"
      },
      "mapping": {
        "headerRow": "Primul rând este antet",
        "nameColumn": "Coloană nume",
        "emailColumn": "Coloană email",
        "phoneColumn": "Coloană telefon",
        "notMapped": "— nemapat —",
        "column": "Coloană",
        "preview": "Previzualizare"
      },
      "review": {
        "allValid": "Toți cei {{count}} candidați sunt valizi",
        "summary": "{{valid}} valizi · {{invalid}} invalizi",
        "skipInvalid": "Omite rândurile invalide și importă {{count}} candidați valizi",
        "recheck": "Reverifică",
        "import": "Importă {{count}} candidați",
        "colName": "Nume",
        "colEmail": "Email",
        "colPhone": "Telefon",
        "colStatus": "Status"
      },
      "errors": {
        "nameRequired": "Obligatoriu",
        "emailInvalid": "Email invalid",
        "emailDuplicate": "Email duplicat în acest fișier",
        "phoneInvalid": "Necesită prefixul de țară (ex. +40…)"
      },
      "success": {
        "title": "Import finalizat",
        "body": "{{created}} importați, {{conflict}} aveau deja candidaturi (omise), {{error}} eșuate.",
        "done": "Gata"
      }
    },
    "screening": "Screening",
    "aiRanked": "Clasament AI",
    "emptyStage": "Nicio candidatură",
    "emptyTitle": "Niciun candidat încă",
    "emptyDescription": "Adaugă primul candidat pentru a începe evaluarea candidaturilor.",
    "emptySearchDescription": "Niciun candidat nu corespunde căutării tale.",
    "searchPlaceholder": "Caută după nume, email sau telefon",
    "createDialog": {
      "title": "Adaugă candidatură",
      "name": "Nume complet",
      "namePlaceholder": "ex. Ion Popescu",
      "email": "Adresă de email",
      "emailPlaceholder": "ex. ion@exemplu.com",
      "phoneNumber": "Număr de telefon",
      "phoneNumberPlaceholder": "ex. 0712-345-678",
      "phoneCountryCode": "Prefix țară",
      "phoneCountryCodePlaceholder": "ex. +40",
      "submit": "Creează candidatura"
    },
    "errors": {
      "conflict": "Acest candidat are deja o candidatură pentru acest job."
    },
    "detail": {
      "title": "Detalii candidatură",
      "tabs": {
        "application": "Candidatură",
        "profile": "Profil",
        "activity": "Activitate"
      },
      "stage": "Etapă",
      "interviewLink": "Link interviu",
      "interviewStatus": "Status interviu",
      "copyLink": "Copiază linkul",
      "linkCopied": "Copiat!",
      "noInterview": "Nicio sesiune de interviu găsită",
      "noResults": {
        "title": "Interviu nefinalizat",
        "description": "Acest candidat nu a susținut încă interviul. Distribuie linkul de interviu pentru a începe."
      },
      "inProgress": {
        "title": "Interviu în desfășurare",
        "description": "Acest candidat a început interviul. Rezultatele vor apărea aici odată finalizat."
      },
      "openInterview": "Deschide interviul",
      "commChannel": {
        "label": "Trimite prin",
        "manual": "Manual",
        "email": "Email",
        "sms": "SMS",
        "whatsapp": "WhatsApp"
      },
      "status": {
        "pending": "În așteptare",
        "in_progress": "În desfășurare",
        "completed": "Finalizat",
        "expired": "Expirat"
      }
    }
  },
  "pagination": {
    "rowsPerPage": "Rânduri pe pagină",
    "rowsSelected": "{{count}} din {{total}} rând(uri) selectate.",
    "pageOf": "Pagina {{page}} din {{total}}",
    "previous": "Anterior",
    "next": "Următor"
  },
  "screening": {
    "title": "Interviu de screening",
    "aiDisclosure": "Discuți cu Sara, un asistent AI de recrutare",
    "selectLanguage": "Selectează limba preferată",
    "selectLanguageDescription": "Interviul va fi desfășurat în limba pe care o alegi",
    "startInterview": "Începe interviul",
    "previewJobTitle": "Job exemplu — Companie exemplu",
    "typeMessage": "Scrie mesajul tău...",
    "send": "Trimite",
    "typing": "Sara scrie...",
    "submitInterview": "Trimite interviul",
    "loading": "Se încarcă interviul...",
    "completed": {
      "title": "Interviu finalizat",
      "submitted": "Interviul a fost trimis cu succes",
      "message": "Mulțumim pentru completarea interviului pentru {{jobTitle}}. Un recrutor va examina răspunsurile tale și te va contacta."
    },
    "expired": {
      "title": "Interviu expirat",
      "message": "Acest link de interviu a expirat. Te rugăm să contactezi recrutorul pentru o nouă invitație."
    },
    "notFound": {
      "title": "Interviu negăsit",
      "message": "Acest link de interviu nu este valid. Te rugăm să verifici linkul și să încerci din nou."
    },
    "feedback": {
      "helpUsImprove": "Ajută-ne să ne îmbunătățim",
      "teaser": "Cum a fost experiența interviului?",
      "overallPrompt": "Cum a fost experiența generală a interviului?",
      "disclaimer": "Ne-ar plăcea feedback-ul tău — este anonim și nu va afecta candidatura ta.",
      "prompt": "Cum a decurs interviul?",
      "good": "Foarte bine",
      "bad": "Rău",
      "notesLabel": "Alte comentarii?",
      "notesPlaceholder": "Spune-ne mai mult (opțional)...",
      "skip": "Omite",
      "submit": "Trimite feedback",
      "submitError": "Nu s-a putut trimite feedback-ul. Te rugăm să încerci din nou."
    },
    "technicalIssue": {
      "buttonLabel": "Problemă tehnică?",
      "modalTitle": "Raportează o problemă tehnică",
      "modalDescription": "Descrie problema pe care ai întâmpinat-o. Feedback-ul tău va fi trimis și interviul va reporni.",
      "notesLabel": "Ce s-a întâmplat?",
      "notesPlaceholder": "ex. Pagina a înghețat și am pierdut progresul...",
      "submitButton": "Trimite feedback și repornește",
      "submitError": "Nu s-a putut trimite. Te rugăm să încerci din nou.",
      "cancel": "Anulează"
    },
    "error": {
      "title": "Ceva nu a funcționat",
      "message": "A apărut o eroare. Te rugăm să încerci mai târziu.",
      "sendFailed": "Nu s-a putut trimite mesajul. Te rugăm să încerci din nou."
    },
    "languages": {
      "en": "Engleză",
      "da": "Daneză",
      "sv": "Suedeză",
      "de": "Germană",
      "fr": "Franceză",
      "es": "Spaniolă",
      "nl": "Olandeză",
      "pl": "Poloneză",
      "fi": "Finlandeză",
      "ro": "Română"
    },
    "landing": {
      "badge": "INTERVIU DE ANGAJARE",
      "greeting": "Bună {{name}}! Ne bucurăm că ești aici. Aceasta este o invitație pentru un scurt interviu online de screening cu o IA pentru a te cunoaște mai bine. Susține-l când ești pregătit.",
      "startChat": "Începe interviul text",
      "startVoice": "Începe interviul vocal",
      "or": "sau",
      "minutes": "{{count}} minute",
      "questions": "{{count}} întrebări"
    },
    "modality": {
      "title": "Alege formatul interviului",
      "description": "Selectează cum dorești să finalizezi interviul",
      "text": "Interviu text",
      "textDescription": "Scrie răspunsurile într-un chat",
      "voice": "Interviu vocal",
      "voiceDescription": "Spune răspunsurile cu voce tare"
    },
    "deviceTest": {
      "title": "Verifică audio",
      "description": "Asigură-te că microfonul și difuzoarele funcționează înainte de a începe",
      "microphone": "Microfon",
      "speakers": "Difuzoare",
      "testMicrophone": "Permite accesul la microfon",
      "testSpeakers": "Redă sunet de test",
      "playAgain": "Redă din nou",
      "requestingPermission": "Se solicită permisiunea...",
      "microphoneDenied": "Accesul la microfon a fost refuzat. Te rugăm să permiți accesul din setările browserului.",
      "confirm": "Totul funcționează — începe interviul"
    },
    "voice": {
      "title": "Interviu vocal",
      "connecting": "Se conectează...",
      "recording": "Înregistrare",
      "interviewInProgress": "Interviu în desfășurare",
      "inProgress": "Interviu în desfășurare — vorbește natural",
      "muted": "Microfonul tău este dezactivat",
      "finished": "Interviu finalizat — mulțumim!",
      "alreadyInProgress": "Interviu în desfășurare",
      "alreadyInProgressMessage": "Interviul tău vocal este în prezent activ. Repornirea va anula sesiunea curentă — fă asta doar dacă nu mai ești conectat.",
      "retryButton": "Repornește interviul"
    }
  },
  "scoring": {
    "title": "Rezultatele interviului",
    "pending": "Punctarea este în curs...",
    "processing": "AI evaluează interviul...",
    "failed": "Punctarea a eșuat",
    "overallScore": "Scor general",
    "overallScoreTooltip": "Scor de la 0–100 bazat pe media tuturor scorurilor la întrebările de evaluare, ajustat pentru eligibilitate și așteptările jobului.",
    "outcome": "Rezultat",
    "outcomes": {
      "pass": "Admis",
      "fail": "Respins"
    },
    "summary": "Rezumat",
    "eligibility": "Eligibilitate",
    "niceToHave": "De dorit",
    "expectations": "Așteptări job",
    "assessment": "Evaluare",
    "information": "Colectare informații",
    "scoringAnchors": "Ancore de punctare",
    "candidateAnswer": "Răspunsul candidatului",
    "transcript": "Transcrierea interviului",
    "viewInTranscript": "Vezi în transcriere",
    "copyPasteDetected": "Răspuns copiat-lipit",
    "copyPasteWarning": "Copiere-lipire detectată în acest interviu",
    "copyPasteWarningTooltip": "Unul sau mai multe răspunsuri ale candidatului au fost lipite în timpul interviului. Acest lucru poate indica faptul că candidatul a folosit răspunsuri pregătite.",
    "verdicts": {
      "pass": "Admis",
      "fail": "Respins",
      "unsure": "Incert",
      "review": "Necesită revizuire"
    },
    "optional": "Opțional",
    "averageScore": "Scor mediu la întrebări",
    "reasoning": "Raționament",
    "evidence": "Dovezi",
    "backToJob": "Înapoi la job",
    "overrideDialog": {
      "title": "Suprascrie scorul",
      "titleVerdict": "Suprascrie verdictul",
      "currentValue": "Valoare curentă",
      "newValue": "Valoare nouă",
      "reason": "Motivul suprascrierii",
      "reasonPlaceholder": "Explică de ce modifici acest scor...",
      "reasonMinLength": "Minimum {{min}} caractere necesare",
      "save": "Salvează suprascrierea",
      "cancel": "Anulează",
      "error": "Nu s-a putut salva suprascrierea. Te rugăm să încerci din nou."
    }
  },
  "workflows": {
    "title": "Flux de lucru",
    "description": "Configurează etapele prin care trec candidaturile în procesul tău de angajare.",
    "stages": {
      "title": "Etapele pipeline-ului",
      "subtitle": "Trage pentru a reordona. Candidaturile progresează prin aceste etape de sus în jos.",
      "system": "Sistem",
      "manage": "Gestionează etapele",
      "addStage": "Adaugă etapă",
      "editStage": "Editează etapă",
      "deleteStage": "Șterge etapă",
      "stageName": "Numele etapei",
      "stageNamePlaceholder": "ex. Interviu telefonic",
      "stageColor": "Culoare",
      "deleteConfirm": "Ștergi această etapă? Candidaturile din această etapă trebuie mutate mai întâi.",
      "systemProtected": "Etapele de sistem nu pot fi șterse",
      "hasApplications": "Această etapă mai are candidaturi alocate"
    }
  },
  "communications": {
    "title": "Comunicări agent",
    "languageSelector": "Limbă",
    "tabs": {
      "sms": "SMS",
      "email": "Email"
    },
    "emailSubject": "Subiect",
    "emailBody": "Conținut",
    "variables": {
      "applicantName": "Numele candidatului",
      "jobTitle": "Titlul jobului",
      "jobEmployer": "Angajatorul jobului",
      "jobLocation": "Locația jobului",
      "jobDescription": "Descrierea jobului",
      "recruiterName": "Numele recrutorului",
      "inviteUrl": "URL invitație"
    },
    "actions": {
      "edit": "Editează",
      "save": "Salvează modificările",
      "reset": "Resetează la implicit",
      "saved": "Șablon salvat",
      "resetDone": "Revenit la implicit"
    },
    "nodes": {
      "interviewIntro": "Introducere interviu",
      "interviewOutro": "Încheiere interviu",
      "reminderToFinish": "Memento de finalizare",
      "voiceAndChat": "Voce și chat",
      "emailsAndSms": "Emailuri și SMS",
      "comingSoon": "În curând"
    },
    "characters": "{{count}}/{{max}} Caractere",
    "smsSegments": "{{count}} mesaje SMS ({{size}} caractere/segment)",
    "smsUnicodeWarning": "Acest mesaj conține emoji-uri sau caractere speciale care necesită codificare Unicode, reducând limita la 67 de caractere per SMS.",
    "invite": {
      "title": "Invitație candidat",
      "description": "Candidații primesc acest mesaj când sunt adăugați la un job. Emailul include automat un link către interviu.",
      "email": {
        "subject": "Ești invitat la interviul pentru {{jobTitle}}! 🎯",
        "body": "<p>Bună {{applicantName}},</p><p>Ai fost invitat să completezi un scurt interviu online de screening cu intervievatorul nostru AI (Inteligență Artificială) pentru poziția de <strong>{{jobTitle}}</strong> la <strong>{{jobEmployer}}</strong>.</p><p>Este un mod simplu prin care putem să te cunoaștem mai bine — susține-l oricând ești pregătit, de oriunde. Durează doar câteva minute!</p><p><a href=\"{{inviteUrl}}\">Începe interviul</a></p><p>Succes!<br>{{jobEmployer}}</p>"
      },
      "sms": "Bună {{applicantName}}, sunt Sara, asistentul AI (Inteligență Artificială) pentru angajare al {{jobEmployer}}. Ai fost invitat la un interviu pentru {{jobTitle}}. Durează doar câteva minute: {{inviteUrl}} (Fără răspunsuri)"
    },
    "reminder": {
      "title": "Memento interviu",
      "description": "Trimis automat dacă un candidat nu a început interviul în decurs de 24 de ore de la primirea invitației.",
      "email": {
        "subject": "Nu uita de interviul tău pentru {{jobTitle}}",
        "body": "<p>Bună {{applicantName}},</p><p>Am observat că nu ai completat încă interviul de screening AI (Inteligență Artificială) pentru poziția de <strong>{{jobTitle}}</strong> la <strong>{{jobEmployer}}</strong>.</p><p>Aceasta este șansa ta de a face un pas înainte — durează doar câteva minute, iar completarea îți va crește șansele de a avansa la etapa următoare.</p><p><a href=\"{{inviteUrl}}\">Completează interviul acum</a></p><p>Cu respect,<br>{{jobEmployer}}</p>"
      },
      "sms": "Bună {{applicantName}}, doar un memento prietenos — nu ai completat încă interviul pentru {{jobTitle}} la {{jobEmployer}}. Durează doar câteva minute și îți crește șansele: {{inviteUrl}} — Sara"
    },
    "emailBodyPlaceholder": "Scrie emailul tău...",
    "preview": {
      "outroSampleIntro": "Asta a fost tot — mulțumim pentru răspunsuri!",
      "outroSampleAnswer": "Nicio problemă, cu plăcere."
    },
    "intro": {
      "title": "Introducere interviu",
      "description": "Mesajul exact de deschidere pe care Sara îl va spune pentru a saluta candidatul și a întreba dacă este pregătit să înceapă.",
      "scriptLabel": "Mesaj de introducere",
      "scriptPlaceholder": "Scrie mesajul exact de deschidere pe care Sara ar trebui să-l spună...",
      "defaultScript": "Bună! Sunt Sara, un asistent AI de recrutare pentru {{jobEmployer}}. Mulțumesc că ți-ai făcut timp pentru interviul pentru rolul de {{jobTitle}} — va dura doar câteva minute. Ești pregătit să începem? 😊"
    },
    "outro": {
      "title": "Încheiere interviu",
      "description": "Mesajul exact de încheiere pe care Sara îl va spune după ce toate întrebările au fost răspunse.",
      "scriptLabel": "Mesaj de încheiere",
      "scriptPlaceholder": "Scrie mesajul exact de încheiere pe care Sara ar trebui să-l spună...",
      "defaultScript": "Asta a fost tot — mulțumesc foarte mult pentru timpul acordat astăzi! Un recrutor va examina răspunsurile tale și te va contacta. Succes! 🙂"
    }
  },
  "activity": {
    "title": "Activitate",
    "stageChange": "Mutat din {{from}} în {{to}}",
    "interviewCompleted": "Interviu de screening finalizat",
    "scoreReceived": "Scor primit: {{score}}/100",
    "applicationCreated": "Candidatură creată",
    "noteAdded": "Notă adăugată",
    "bySystem": "Sistem",
    "byAi": "AI",
    "empty": "Nicio activitate încă",
    "emptyTitle": "Nicio activitate încă",
    "emptyDescription": "Acțiunile și evenimentele pentru acest candidat vor apărea aici."
  },
  "atsPush": {
    "title": "Status trimitere ATS",
    "retry": "Reîncearcă trimiterea ATS",
    "retrying": "Se reîncearcă...",
    "rerunStep": "Rulează din nou acest pas",
    "rerunConfirm": "Acest pas s-a finalizat deja cu succes. Rularea din nou poate crea date duplicate în ATS. Continui?",
    "steps": {
      "transcript": "Transcriere",
      "stage_move": "Mutare etapă"
    },
    "status": {
      "completed": "Trimis",
      "failed": "Eșuat",
      "pending": "În așteptare"
    },
    "note": {
      "title": "Interviu de screening AI",
      "outcome": "Rezultat",
      "score": "Scor",
      "summary": "Rezumat",
      "eligibility": "Eligibilitate",
      "assessment": "Evaluare",
      "transcript": "Transcriere",
      "candidate": "Candidat",
      "interviewer": "Intervievator",
      "pass": "Admis",
      "fail": "Respins",
      "review": "Revizuire",
      "shortlist": "Selectare",
      "reject": "Respingere",
      "viewProfile": "Vezi profilul candidatului în Kiku",
      "transcriptAndAssessment": "TRANSCRIERE ȘI EVALUARE",
      "intro": "Introducere",
      "eligibilityQuestions": "Întrebări de eligibilitate",
      "jobExpectations": "Așteptări job",
      "assessmentQuestions": "Întrebări de evaluare",
      "outro": "Încheiere",
      "assessmentExplanation": "EXPLICAȚIA EVALUĂRII",
      "unsure": "Incert",
      "viewInKiku": "VIZUALIZEAZĂ ÎN KIKU PENTRU MAI MULTE DETALII",
      "viewProfileLink": "Vezi profilul candidatului în Kiku pentru a vedea explicațiile scorurilor"
    }
  },
  "topbar": {
    "whatsNew": "Noutăți",
    "help": "Ajutor",
    "notifications": "Notificări"
  },
  "extension_candidate_banner": {
    "description": "Vezi detaliile candidatului.",
    "description_with_transcript": "Vezi transcrierea screening-ului și detaliile candidatului.",
    "open_in_kiku": "Deschide",
    "dismiss": "Închide"
  },
  "languages": {
    "en": "Engleză",
    "da": "Daneză",
    "sv": "Suedeză",
    "de": "Germană",
    "fr": "Franceză",
    "es": "Spaniolă",
    "nl": "Olandeză",
    "pl": "Poloneză",
    "fi": "Finlandeză",
    "ro": "Română"
  },
  "environmentBanner": {
    "development": "Dezvoltare",
    "test": "Test"
  },
  "notFound": {
    "title": "Pagina nu a fost găsită",
    "description": "Pagina pe care o cauți nu există sau a fost mutată.",
    "goHome": "Înapoi la Kiku"
  },
  "candidateProfile": {
    "title": "Candidați",
    "cv": {
      "title": "CV / Rezumat",
      "upload": "Încarcă CV",
      "replace": "Înlocuiește CV",
      "uploadDescription": "Încarcă un CV pentru a extrage date structurate de profil",
      "uploadLimit": "Max 10 MB — PDF, DOCX, PNG, JPG, WEBP",
      "viewOriginal": "Vezi CV-ul original",
      "status": {
        "pending": "În coadă",
        "processing": "Se procesează...",
        "done": "Procesat",
        "failed": "Procesarea a eșuat"
      },
      "parsed": {
        "title": "Profil extras",
        "skills": "Competențe",
        "experience": "Experiență",
        "education": "Educație",
        "languages": "Limbi",
        "certifications": "Certificări",
        "present": "Prezent"
      },
      "errors": {
        "unsupportedType": "Tip de fișier neacceptat. Te rugăm să încarci un PDF, DOCX, PNG, JPG sau WEBP.",
        "tooLarge": "Fișier prea mare. Dimensiunea maximă este 10 MB.",
        "uploadFailed": "Nu s-a putut încărca CV-ul. Te rugăm să încerci din nou."
      }
    }
  },
  "results": {
    "exportLabel": "Exportă",
    "exportCsv": "Exportă CSV",
    "csv": {
      "headers": {
        "candidateName": "Numele candidatului",
        "email": "Email",
        "role": "Rol",
        "stage": "Etapă",
        "overallScore": "Scor general",
        "outcome": "Rezultat",
        "eligibility": "Eligibilitate",
        "expectations": "Așteptări",
        "avgScore": "Scor mediu",
        "interviewDate": "Data interviului",
        "status": "Status"
      }
    },
    "emptyTitle": "Niciun rezultat încă",
    "emptyDescription": "Interviurile finalizate vor apărea aici.",
    "columns": {
      "candidate": "Candidat",
      "stage": "Etapă",
      "status": "Status",
      "score": "Scor",
      "outcome": "Rezultat",
      "eligibility": "Eligibilitate",
      "expectations": "Așteptări",
      "avgScore": "Scor mediu",
      "interviewDate": "Data interviului",
      "question": "Întrebare"
    },
    "statusLabels": {
      "pending": "În așteptare",
      "processing": "Se procesează",
      "completed": "Finalizat",
      "failed": "Eșuat",
      "no_interview": "Fără interviu"
    },
    "questionSections": {
      "eligibility": "Eligibilitate",
      "job_preview": "Așteptări",
      "nice_to_have": "De dorit",
      "assessment": "Evaluare",
      "information": "Informații"
    },
    "fields": {
      "reasoning": "Raționament",
      "evidence": "Dovezi",
      "response": "Răspuns",
      "avgScoreLabel": "Scor mediu",
      "interviewDate": "Data interviului"
    }
  },
  "orgSettings": {
    "title": "Setări organizație",
    "branding": {
      "title": "Branding",
      "logo": "Logo organizație",
      "logoDescription": "Încarcă un logo pentru a înlocui logo-ul implicit Kiku din bara de navigare.",
      "uploadLogo": "Încarcă logo",
      "removeLogo": "Elimină logo",
      "logoHint": "PNG, JPG, WebP sau SVG. Max 2 MB.",
      "uploadSuccess": "Logo actualizat cu succes",
      "removeSuccess": "Logo eliminat",
      "uploadError": "Nu s-a putut încărca logo-ul"
    },
    "timezone": {
      "title": "Fus orar",
      "description": "Setează fusul orar implicit pentru programare și afișarea datelor.",
      "label": "Fus orar",
      "saveSuccess": "Fus orar actualizat",
      "saveError": "Nu s-a putut actualiza fusul orar"
    },
    "save": "Salvează modificările"
  },
  "mcp": {
    "title": "Integrare MCP",
    "subtitle": "Conectează asistenți AI la Kiku prin Model Context Protocol",
    "whatIsMcp": "Ce este MCP?",
    "whatIsMcpDescription": "Model Context Protocol (MCP) permite asistenților AI precum Claude, ChatGPT și alte instrumente să interacționeze direct cu Kiku — listând joburi, vizualizând candidați și gestionând procesul de recrutare prin limbaj natural.",
    "serverUrl": "URL server",
    "copyUrl": "Copiază URL",
    "copied": "Copiat!",
    "availableTools": "Instrumente disponibile",
    "toolListJobs": "Caută și listează posturile de muncă cu nume de departament, filtre pentru status, status de configurare și departament.",
    "toolGetJob": "Obține toate detaliile unui post de muncă specific, inclusiv numele departamentului.",
    "toolCreateJob": "Creează un anunț de job nou într-un departament.",
    "toolAdvanceSetup": "Avansează un job prin etapele de configurare (ciornă, întrebări_în_așteptare, pregătit, activ).",
    "toolListApplications": "Listează candidaturile pentru un post cu nume de etapă, status de punctaj și rezultat.",
    "toolGetInterviewResults": "Obține rezultatele interviului AI pentru o candidatură — punctaj, rezultat și detaliere pe întrebări cu raționament.",
    "toolGetPipelineSummary": "Obține un rezumat al pipeline-ului pentru un post — număr de candidați pe etapă cu totaluri admis/respins.",
    "setupTitle": "Configurare cu Claude Desktop",
    "setupStep1": "Deschide Claude Desktop",
    "setupStep2": "Apasă pe Customize în bara laterală stângă",
    "setupStep3": "Apasă pe Connectors, apoi pictograma +, apoi Add custom connector",
    "setupStep4": "Introdu Name: Kiku și URL-ul serverului afișat mai sus",
    "setupStep5": "Apasă Add — Claude poate folosi acum datele tale Kiku"
  }
}
